<template>
  <div class="form-group">
    <dropzone
      class="mb-2 dropzone--with-action"
      @drop="drop"
    >
      <div class="d-flex flex-column align-items-center">
        <file-uploader-illustration @click="resetFileUploader" class="document-import__uploader__icon upload-icon"/>
        <div class="text-center">
          <div class="document-import__uploader__text font-weight-midbold">{{ $t('document.fields.upload_document_here') }}</div>
          <div class="document-import__uploader__text">{{ $t('document.fields.or_click_and_select') }}</div>
        </div>
      </div>

      <div class="file-list file-list--rows d-flex flex-wrap">
        <file-card
          v-if="modelValue"
          :file="modelValue"
          @remove="clearValue"
        />
      </div>

      <input
        ref="fileInput"
        type="file"
        @change="selectFile"
        class="opacity-0"
      >
    </dropzone>
  </div>
</template>

<script>
  import Dropzone from '@/components/files/dropzone';
  import FileCard from '@/components/files/file-card';
  import FileUploaderIllustration from '@/components/illustrations/file-uploader-illustration.vue';
  import { amplitudeService } from '@/models/amplitude-service';

  export default {
    name: 'FileSelect',

    components: { FileUploaderIllustration, FileCard, Dropzone },

    props: {
      // Value supports File or { name: '' }
      modelValue: {
        type: null,
        default: null,
      },
    },

    methods: {
      selectFile(e) {
        if (!e.target.files.length) {
          return;
        }
        amplitudeService.trackEvent('[Frontend] User Uploaded File', { method: 'file_select', page: this.$route.name });
        this.$emit('update:modelValue', e.target.files[0]);
      },

      clearValue() {
        this.$emit('update:modelValue', null);
      },

      drop(file) {
        this.$emit('update:modelValue', file[0]);
      },

      resetFileUploader() {
        if (!this.modelValue) {
          this.$refs.fileInput.value = '';
          this.$refs.fileInput.click();
        }
      },
    },
  };
</script>
